import React from 'react';
import { StyledSwitch } from './StyledSwitch';

interface SwitchWithInputProps {
  isChecked: boolean;
  onSwitch: (checked: boolean) => void;
  style?: React.CSSProperties;
}

const SwitchWithInput: React.FC<SwitchWithInputProps> = ({ isChecked, onSwitch, style }) => {
  return (
    <StyledSwitch checked={isChecked} onChange={(e) => onSwitch(e.target.checked)} style={style} />
  );
};

export default SwitchWithInput;
